import axios from 'axios'
const state = {
  markers: [],
  details: [],
  zoomLevel: '',
  mapThis: '',
  listSearch: []
}

const getters = {
  getZoomLevel (state) {
    return state.zoomLevel
  },
  getMarkers (state) {
    return state.markers
  },
  getDetails (state) {
    return state.details
  },
  getMapThis (state) {
    return state.mapThis
  },
  getListSearch (state) {
    return state.listSearch
  }
}

const mutations = {
  setZoomLevel (state, payload) {
    state.zoomLevel = payload
  },
  setMarkers (state, payload) {
    state.markers = payload
  },
  setDetails (state, payload) {
    state.details = payload
  },
  setMapThis (state, payload) {
    state.mapThis = payload
  },
  setListSearch (state, payload) {
    state.listSearch = payload
  }
}

const actions = {
  setListSearch (context, payload) {
    context.commit('setListSearch', payload)
  },
  apiEstateMarker (context, payload) {
    axios.post('/api/estate/getEstateMarker', payload)
      .then((response) => {
        // console.log(response.data)
        context.commit('setMarkers', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  },
  apiEstateDetail (context, payload) {
    axios.post('/api/estate/getEstateDetail', payload)
      .then((response) => {
        // console.log(response.data)
        context.commit('setDetails', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  },
  apiEstateSelectDetail (context, payload) {
    axios.post('/api/estate/getSelectDetail', payload)
      .then((response) => {
        // console.log(response.data)
        context.commit('setDetails', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    // }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/searchestate.js